import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    querys: {}
  },
  mutations: {
    SET_QUERYS(state, val) {
      state.querys = val
    }
  },
  actions: {
    SET_QUERYS({ commit }, val) {
      commit('SET_QUERYS', val)
    }
  },
  modules: {}
})
